import { chowlyApi } from 'config'

import client from '../chowly'
import { EmailVerificationInput } from '../models'

export const sendVerificationEmail = async (payload: EmailVerificationInput) => {
  await client.post(chowlyApi.sendEmailVerification, payload)
}
